










import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { RouteRecord, Route } from 'vue-router'

@Component({})
export default class Breadcrumb extends Vue {
  private breadcrumbs: RouteRecord[] = []
  private preadcrumbData: any = '首页'
  @Watch('$route')
  private onRouteChange(route: Route) {
    // if you go to the redirect page, do not update the breadcrumbs
    if (route.path.startsWith('/redirect/')) {
      return
    }
    this.getBreadcrumb()
  }
  created() {
    this.getBreadcrumb()
  }
  getBreadcrumb() {
    this.preadcrumbData = this.$route.matched.filter(item => item.path)[0].name
  }
}
